import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function DateOfBirth({ item, index }) {

  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">10/25/1976</div>
    } else {
      return <>
        <div className="col-8">Date Of Birth</div>
        <div className="col-4">10/25/1976</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}